module.exports = __webpack_public_path__ + "img/PL08943.8c7f614a.png";